import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { emptyStringValues } from '@/utils/objects';

import { TClipOcr, TPatchClipOcr } from '../types';

type TPatchClipOcrBody = {
  id: string;
  body: TPatchClipOcr;
};
export async function patchClipOcr({ id, body }: TPatchClipOcrBody): Promise<TClipOcr> {
  return mediaManagerClient
    .patch(`/api/v1/clip_ocr/${id}`, emptyStringValues(body))
    .then(response => response as unknown as TClipOcr);
}

type MutationFn = typeof patchClipOcr;

type TUsePatchClipOcrParams = {
  config?: MutationConfig<MutationFn>;
};

export function usePatchClipOcr({ config }: TUsePatchClipOcrParams = {}) {
  const { t } = useTranslation();
  const { addErrorNotification, addSuccessNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: patchClipOcr,
    onError(error) {
      addErrorNotification(t('No se ha podido actualizar el rótulo del corte'));
      console.error(error);
    },
    onSuccess() {
      addSuccessNotification(t('El rótulo del corte se ha actualizado correctamente'));
    },
  });
}
